module.exports = __webpack_public_path__ + "static/media/recs-hero-line-tablet.e6b25112.svg";